import { Component, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        },
    },
});

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
    state: { error: Error | null } = { error: null };

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: 32, maxWidth: 720, margin: "0 auto" }}>
                    <h1>something went wrong</h1>
                    <pre style={{
                        background: "#1a1a1a", border: "1px solid #333", borderRadius: 8,
                        padding: 12, color: "#da4165", fontSize: "0.85em",
                        whiteSpace: "pre-wrap", wordBreak: "break-word", marginBottom: 16,
                    }}>
                        {String(this.state.error?.stack || this.state.error)}
                    </pre>
                    <button onClick={() => location.reload()} style={{
                        background: "#da4165", color: "white", border: "none",
                        borderRadius: 6, padding: "8px 20px", cursor: "pointer", fontSize: "1em",
                    }}>Reload</button>
                </div>
            );
        }
        return this.props.children;
    }
}

const root = createRoot(document.getElementById("root")!);
root.render(
    <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </ErrorBoundary>
);
